module.exports = __webpack_public_path__ + "static/img/sqtgh5.3a18e04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sqtgh5.png
// module id = VNim
// module chunks = 0